"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var hostPatterns = [
    ['beta', /stage\.cian\.ru$/i],
    ['development', /dev2?\.cian\.ru$/i],
    ['local', /local(\.map)?\.cian\.ru$/i],
    ['local', /^localhost(:\d+)?$/i],
    ['production', /cian\.ru$/i],
];
function calculateEnvironmentByHost(host) {
    for (var _i = 0, hostPatterns_1 = hostPatterns; _i < hostPatterns_1.length; _i++) {
        var hostPattern = hostPatterns_1[_i];
        if (hostPattern[1].test(host)) {
            return hostPattern[0];
        }
    }
    return 'unknown';
}
exports.calculateEnvironmentByHost = calculateEnvironmentByHost;
//# sourceMappingURL=calculate_environment_by_host.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@cian/sentry/~/@cian/utils/lib/shared/calculate_environment_by_host.js
// module id = 379
// module chunks = 0